import { api } from '../../lib/api';
import type { AppContextValue } from '../../lib/appConstants';

export interface AnalysisFilters {
  app: AppContextValue;
  period: 'all' | '30' | '90' | 'custom';
  from?: string;
  to?: string;
  mode: 'all' | 'latest';
  excludeInternal: boolean;
}
export interface DifficultyCounts {
  responses: number;
  accounts: number;
  tooEasy: number;
  justRight: number;
  tooHard: number;
}
export interface LessonAnalysis extends DifficultyCounts {
  lessonId: string;
  title: string;
  topicId: string | null;
  topicTitle: string;
  missingLesson: boolean;
}
export interface StarAnalysis {
  field: 'lessons' | 'plan' | 'stats' | 'quizzes' | 'flashcards';
  responses: number;
  accounts: number;
  mean: number | null;
  distribution: number[];
}
export interface AnalysisGroup {
  app: string;
  difficulty: DifficultyCounts & { lessons: number };
  lessons: LessonAnalysis[];
  stars: StarAnalysis[];
  excluded: Record<'internal' | 'deleted' | 'suspended' | 'unlinked', { difficulty: number; feedback: number }>;
}
export interface FeedbackAnalysis {
  generatedAt: string;
  range: { from: string | null; until: string; timezone: string };
  mode: AnalysisFilters['mode'];
  excludeInternal: boolean;
  groups: AnalysisGroup[];
}

export function fetchFeedbackAnalysis(filters: AnalysisFilters): Promise<FeedbackAnalysis> {
  const params = new URLSearchParams({ app: filters.app, period: filters.period,
    mode: filters.mode, excludeInternal: String(filters.excludeInternal) });
  if (filters.period === 'custom') {
    if (filters.from) params.set('from', filters.from);
    if (filters.to) params.set('to', filters.to);
  }
  return api.get<FeedbackAnalysis>(`/admin/feedback/analysis?${params}`);
}
